import React from 'react';

const BuyerDetails = ({ buyer, onChange }) => {
  return (
    <>
      <div className="form-group">
        <label htmlFor="buyer-name">Buyer Name:</label>
        <input 
          type="text" 
          id="buyer-name" 
          value={buyer.name}
          onChange={(e) => onChange('buyer', 'name', e.target.value)}
          placeholder="Enter buyer name"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="buyer-address">Buyer Address:</label>
        <textarea 
          id="buyer-address" 
          rows="3" 
          value={buyer.address}
          onChange={(e) => onChange('buyer', 'address', e.target.value)}
          placeholder="Enter buyer address"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="buyer-pan">Buyer Pan No:</label>
        <input 
          type="text" 
          id="buyer-pan" 
          value={buyer.pan}
          onChange={(e) => onChange('buyer', 'pan', e.target.value)}
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="buyer-gst">Buyer GST No:</label>
        <input 
          type="text" 
          id="buyer-gst" 
          value={buyer.gst}
          onChange={(e) => onChange('buyer', 'gst', e.target.value)}
          placeholder="Enter buyer GST number"
        />
      </div>
    </>
  );
};

export default BuyerDetails;